export const NOTIFICATIONS_SETTINGS = {
    status: true,
    access: {
        read: true,
        write: true
    }
};
